import React, { useEffect, useState } from 'react';
import { Layout } from '../components/Layout';
import styled from 'styled-components';
import { Text } from '../components/Text';
import { Slider } from '../components/Slider';
import { NewParallaxSlider } from '../components/NewParallaxSlider';
import { Select } from '../components/Select';
import { ServiceCard } from '../components/ServiceCard';
import { ImageLazyLoad } from '../components/ImageLazyLoad';
import gsap, { TimelineMax } from 'gsap';
import ScrollMagic from 'scrollmagic';
import { Counter } from '../components/Counter';
import { TestimonialSlider } from '../components/TestimonialSlider';
import QASprite from '../assets/images/sprite-qa.png';
import Sprite2D3D from '../assets/images/sprite-2d3d.png';
import SpriteCreativeMarketing from '../assets/images/sprite-creativemarketing.png';
import SpriteContentAndDesign from '../assets/images/sprite-contentandgamedes.png';
import SpriteGameEngineering from '../assets/images/sprite-gameengineering.png';
import { PrimaryButton } from '../components/Buttons';
import { MobileParallex } from '../components/MobileParallex/MobileParallex';
import { FullWidthContainer } from '../components/FullWidthContainer';

const ReadMoreWrapper = styled.div`
  margin-top: -30px;

  @media (max-width: 767px) {
    margin-top: 0;
  }
`;

const StyledServiceText = styled.p`
  color: #1d1d1d;
  font-family: AvenirBold;
  font-size: 44px;
  font-weight: 900;
  letter-spacing: -0.15px;
  line-height: 60px;

  @media (max-width: 767px) {
    color: #1d1d1d;
    font-family: AvenirBold;
    font-size: 28px;
    font-weight: 900;
    line-height: 48px;
    text-align: center;
  }
`;

const BlackLine = styled.span`
  margin-top: 8px;
  float: right;
  width: 35px;
  border: 2px solid #1d1d1d;
  margin-right: -20px;
`;

const HighlightText = styled.span`
  // background-color: #febb39;
  background: linear-gradient(to right, rgb(254, 187, 57) 50%, transparent 50%) 105% / 210%
    no-repeat;
  background-repeat: no-repeat;
  background-position-x: 100%;
  font-family: AvenirBold;
  padding-top: 5px;
  padding-bottom: 1px;
`;

const AboutUsSection = styled.section`
  height: max-content;
`;

const HeadContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 65px);
  width: 100%;
  // background-color: #1c0a1c;
  position: relative;
  overflow: hidden;

  .background {
    position: absolute;
    top: 0px;
    width: 100%;
    height: 100%;
  }
  .spaceman {
    position: absolute;
    bottom: 54%;
    right: 0;
    width: 33%;

    @media (max-width: 576px) {
      position: absolute;
      bottom: 38%;
      right: -60px;
      width: 33%;
    }
  }
  .bottom {
    position: absolute;
    bottom: 0px;
    // height: 10%;
    width: 100%;
  }
  .rover {
    bottom: 10px;
    width: 2%;
  }
  .gatsby-image-wrapper {
    position: static !important;
  }
`;

const SelectBelowLabel = styled.p`
  color: #1d1d1d;
  font-family: AvenirMedium;
  font-size: 48px;
  font-weight: 900;
  letter-spacing: -0.15px;
  line-height: 60px;

  @media (min-witdh: 577px) and (max-width: 992px) {
    font-size: 36px;
    font-weight: 900;
    line-height: 48px;
  }

  @media (max-width: 576px) {
    font-size: 32px;
    font-weight: 900;
    letter-spacing: -0.09px;
    line-height: 36px;
  }
`;

const StyledHeaderText = styled.p`
  color: #fff;
  font-family: AvenirBold;
  font-size: 57px;
  letter-spacing: 2.78pxpx;
  line-height: 60px;
  max-width: 450px;
  text-transform: uppercase;

  .counter {
    padding-top: 90px;
    text-transform: capitalize;
  }

  @media (max-width: 767px) {
    color: #ffffff;
    font-family: AvenirBold;
    font-size: 48px;
    font-weight: 900;
    letter-spacing: 2.22px;
    line-height: 56px;
  }

  @media (max-width: 576px) {
    width: 297px;
    color: #ffffff;
    font-family: AvenirBold;
    font-size: 36px;
    font-weight: 900;
    letter-spacing: 1.67px;
    line-height: 48px;
  }
`;
const CounterContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-right: 10%;
`;

const OurStoryTextHighlight = styled.span`
  background: linear-gradient(to right, rgb(254, 187, 57) 50%, transparent 50%) 105% / 210%
    no-repeat;
  background-repeat: no-repeat;
  background-position-x: 100%;
`;

const HeaderGreetingText = styled.p`
  color: #c2b7c2;
  font-family: Avenir;
  font-size: 22px;
  font-weight: 900;
  letter-spacing: 2.2px;
  line-height: 60px;
  text-transform: capitalize;

  @media (max-width: 576px) {
    color: #c2b7c2;
    font-family: Avenir;
    font-size: 25px;
    font-weight: 900;
    letter-spacing: 1.65px;
    line-height: 25px;
    margin-bottom: 10px;
  }
`;

const StarImage = styled.div`
  width: 250px;
  height: 250px;
  position: absolute;
  top: 70px;
  right: 80px;

  @media (max-width: 576px) {
    width: 150px;
    height: 150px;
    position: absolute;
    top: 70px;
    right: 80px;
  }
`;

const SmallSpacerDiv = styled.div`
  height: 50px;

  @media (max-width: 566px) {
    height: 30px;
  }
`;

const SpacerDiv = styled.div`
  height: 90px;

  @media (max-width: 566px) {
    height: 50px;
  }
`;

const mobileParallexData = [
  {
    url: 'parallax1.jpg',
    text: 'Our great exploration...',
    name: 'Run Sheeda Run',
    subText:
      'Join Sheeda, a young boy with big dreams and lightning speed as he zips through the streets of Pakistan’s liveliest cities!',
    buttonText: 'Checkout More Work',
    to: 'https://www.facebook.com/runsheedarun/',
  },
];
const sliderData = [
  {
    url: 'parallax2.jpg',
    text: 'Explottens',
    buttonText: 'Visit Right Now',
    to: 'https://explottens.com',
  },
  {
    url: 'parallax3.jpg',
    text: 'Kit-kind needs a hero...',
    description:
      'Explottens is a heart pumping, hair raising, pawtastic shoot ’em up that follows K.I.T the pilot as he battles the ferocious felines known as K.L.A.W!',
    // buttonText: 'Go To Website',
    // to: 'https://explottens.com'
  },
  {
    url: 'parallax1.jpg',
    text: 'Run Sheeda Run',
    description:
      'Join Sheeda, a young boy with big dreams and lightning speed as he zips through the streets of Pakistan’s liveliest cities!',
  },
  {
    url: 'parallax1.jpg',
    text: 'Bhag Sheedaay',
    description:
      "Oh, and with Sheeda as your personal tour guide, you'll be able to see Lahore like you've never seen before!",
  },
];

const testimonialData = [
  {
    image: 'pocketgems.png',
    name: ' Amy Claussen, Pocketgems',
    review:
      'Working with WeRPlay’s content designers, artists, and QA team has been one of the great joys of my career. They are so much more than an “outsource” company - they are artistic collaborators, eagle-eyed QA support, experts at refining process, game to do any task no matter how large or data-entryish, and after years of working together, they are great friends. Whenever I’ve needed extra support, my first question has been, “Can we work with WeRPlay?” I enthusiastically recommend them both as talented gamemakers and people who are a joy to work with.',
  },
  {
    image: 'rockyou.png',
    name: 'Stanley Young, RockYou',
    review:
      "I don't have any negatives to say as your team has been truly fantastic and a pleasure to work with. Your team works incredibly hard, and most importantly is reliable and can deliver assets on time in a prompt fashion. One thing if applicable, your team chimes in with ideas on what they think might be great additions to the videos. It's clear that your team is incredibly talented, knowledgeable, and experienced in the gaming space, so offering your expertise or ideas from your team's perspective would only help further strengthen the relationships between clients and your team.",
  },
  {
    image: 'backflip.png',
    name: 'Maggie Wilkens, Backflip Studios',
    review:
      'We have worked with We.R.Play for over a year, they are our go-to agency for static and video ads as well as storefront visuals. We like the team because they understand our brand and consistently produce high quality artwork. I especially appreciate that I can send over an idea and they run with it – often enhancing our initial pitch. I also appreciate that they provide variations and alternate styles when needed. Their pricing is flexible and competitive and they are extremely fast. We can always rely on WeRPlay to make deadlines.',
  },
];

const IndexPage = () => {
  const [selectedOption, setSelectOption] = useState('0');
  
  const textHighlightAnimation = () => {
    var textAnimation = new TimelineMax();
    textAnimation.to('.testTextAnimation', 1, {
      'background-position-x': '0%',
    });
    textAnimation.to('.testTextAnimation', 1, {
      'background-position-x': '-100%',
    });
  };

  const sectionAnimation = (sectionName) => {
    var t2 = gsap.timeline({
      triggerElement: {
        trigger: sectionName,
        start: 'top center',
      },
    });
    t2.fromTo(
      '.' + sectionName + ', .' + sectionName + ' .row',
      { x: -100, y: 0, stagger: 0.3 },
      { x: 0, y: 0, opacity: 1, stagger: 0.3 },
    );
  };

  const sectionAnimationBottomUp = (sectionName) => {
    var t3 = new gsap.timeline({
      trigger: sectionName,
      start: 'top center',
    });
    t3.from('.' + sectionName + ', .' + sectionName + ' .row', { x: 0, y: 70 });
  };

  useEffect(() => {
    var controller = new ScrollMagic.Controller();
    new ScrollMagic.Scene({
      triggerElement: '.aboutUs',
      reverse: false,
      triggerHook: 0.7,
    })
      .on('enter', function() {
        sectionAnimation('aboutUs');
      })
      .addTo(controller);
    new ScrollMagic.Scene({
      triggerElement: '.thingsWeDo',
      reverse: false,
      triggerHook: 0.7,
    })
      .on('enter', function() {
        sectionAnimationBottomUp('thingsWeDo');
      })
      .addTo(controller);
    new ScrollMagic.Scene({
      triggerElement: '.parallaxContainer',
      reverse: false,
      triggerHook: 0.7,
    })
      .on('enter', function() {
        sectionAnimationBottomUp('parallaxContainer');
      })
      .addTo(controller);
    new ScrollMagic.Scene({
      triggerElement: '.testTextAnimation',
      // triggerHook: 0.7
    })
      .on('add', function() {
        textHighlightAnimation();
      })
      .addTo(controller);
  }, []);

  return (
    <Layout mode={'dark'}>
      <HeadContainer>
        <div className='background'>
          <ImageLazyLoad src='Background.jpg' imgStyle={{ objectPosition: 'top right' }} />
        </div>
        <div className='spaceman'>
          <ImageLazyLoad src='Spaceman.png' />
        </div>

        <div className='bottom'>
          <ImageLazyLoad src='BottomRover.png' />
        </div>
        <div
          className='container d-flex flex-column'
          style={{ position: 'absolute', top: '15%', height: '80%' }}>
          <HeaderGreetingText>Greetings Earthlings!</HeaderGreetingText>
          <StyledHeaderText>
            You Have Successfully Landed <br />
            on{' '}
            <OurStoryTextHighlight className='testTextAnimation'>we.R.play</OurStoryTextHighlight>
          </StyledHeaderText>
          {/* To Show Counter */}
          {/* <CounterContainer></CounterContainer> */}
          <div className='counter'>{/* <Counter sample={false} /> */}</div>
        </div>
      </HeadContainer>
      <div className='container'>
        <SpacerDiv />
        <SpacerDiv />
        <AboutUsSection className='d-flex aboutUs'>
          <div className='my-auto'>
            <div className='col-md-5 p-0'>
              <Text type='h1' color='#000' backgroundColor='#fff'>
                Something about us
              </Text>
            </div>
            <div className='row'>
              <div className='col-12 col-md-4 py-3 py-sm-0'>
                <p style={{ color: 'grey' }}>
                  Apart from being an alien space station that’s suspended in the Earth’s orbit
                  somewhere above Islamabad, Pakistan
                </p>
              </div>
              <div className=' d-none d-md-block col-md-1'>
                <BlackLine />
              </div>
              <div className='col-12 col-md-7'>
                <Text>
                  We are also a digital entertainment studio that works on and around mobile games.{' '}
                  <strong>we.R.play</strong> is the largest game developers in Pakistan, dedicated
                  to providing high quality games and art to publishers and developers throughout
                  planet Earth.
                </Text>
                <br />
                <Text>
                  we.R.play offers lots of creative services ranging from{' '}
                  <HighlightText className='testTextAnimation'>
                    QA, 2D & 3D Art, Video & Static Ads, Content & Game Design, Game
                    Engineering&nbsp;
                  </HighlightText>
                  plus secret extraterrestrial services to protect your planet.
                </Text>
              </div>
              <ReadMoreWrapper className='py-4 py-lg-0 ml-3'>
                <PrimaryButton text='Read More' to='/about' invert />
              </ReadMoreWrapper>
            </div>
          </div>
        </AboutUsSection>
        <SpacerDiv />
        <SpacerDiv />
        <div className='col-12 col-sm-12 col-md-12 thingsWeDo py-0 my-0 my-md-4 px-0'>
          <StyledServiceText>
            Things we can do; with futuristic quality at supersonic speed…
          </StyledServiceText>
          <div className='row justify-content-center justify-content-sm-start'>
            <div className='col-9 col-sm-4'>
              <ServiceCard
                title='Quality Assurance'
                to='/services'
                imgSrc={QASprite}
                steps={18}
                state={{ selected: '4' }}
              />
            </div>
            <div className='col-9 col-sm-4'>
              <ServiceCard
                title='Content & Game Design'
                to='/services'
                imgSrc={SpriteContentAndDesign}
                steps={19}
                state={{ selected: '1' }}
              />
            </div>
            <div className='col-9 col-sm-4'>
              <ServiceCard
                title='Game Engineering'
                to='/services'
                imgSrc={SpriteGameEngineering}
                steps={18}
                state={{ selected: '3' }}
              />
            </div>
            <div className='col-9 col-sm-4'>
              <ServiceCard
                title='Creative Marketing'
                to='/services'
                imgSrc={SpriteCreativeMarketing}
                steps={16}
                state={{ selected: '5' }}
              />
            </div>
            <div className='col-9 col-sm-4'>
              <ServiceCard
                title='2D & 3D Art'
                to='/services'
                imgSrc={Sprite2D3D}
                state={{ selected: '2' }}
                steps={17}
              />
            </div>
          </div>
        </div>
        <SpacerDiv />
        <SpacerDiv />
        <div style={{ marginLeft: '-15px' }}>
          <MobileParallex data={mobileParallexData} />
        </div>
      </div>
      <div id='sliderContainer' style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
        <NewParallaxSlider data={sliderData} />
      </div>
      <div className='container'>
        <div className='py-4 my-4'>
          <SmallSpacerDiv />
          <TestimonialSlider items={testimonialData} />
        </div>
      </div>
    </Layout>
  );
};

export default IndexPage;
